import {
  GET_PAST_PURCHASES,
  GET_TRANSACTIONS,
  GET_SERVICE_PRICES,
  GET_PRICE_GROUPS,
  GET_CREDITS,
  GRADING_SUBMITTED,
  PAYMENT_SUCCESS,
  GET_REVIEWER_INVOICES,
  GET_REVIEWER_PAYMENT_DETAILS,
  UPDATE_REVIEWER_PAYMENT_DETAILS,
  APPROVE_REVIEWER_INVOICE,
  REJECT_REVIEWER_INVOICE,
  GET_REVIEWER_INVOICE_PDF,
} from '../actions/types.js';
import { AUDIT_SERVICE_PRODUCT_CODE, DR_FULL, PRODUCT_CODE_TO_SERVICE_NUM } from '../constants/constants';

const initialState = {
  transactions: null,
  pastPurchases: null,
  servicePrices: null,
  priceGroups: [],
  reviewerInvoices: [],
  reviewerPaymentDetails: null,
  reviewerInvoicePdf: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_PRICE_GROUPS:
      return {
        ...state,
        priceGroups: action.payload,
      };
    case PAYMENT_SUCCESS:
      if (typeof action.payload !== Number) {
        return state;
      }
      return {
        ...state,
        credits: action.payload,
      };
    case GET_SERVICE_PRICES:
      let servicePrices = {};
      action.payload.forEach((price) => {
        const serviceNum = PRODUCT_CODE_TO_SERVICE_NUM[price.product_code];
        let newPrice = { ...price };
        servicePrices = { ...servicePrices, [serviceNum]: newPrice };
      });
      return {
        ...state,
        servicePrices,
      };
    case GET_CREDITS:
      return {
        ...state,
        //credits: action.payload.unit_credits
      };
    case GRADING_SUBMITTED:
      return {
        ...state,
      };
    case GET_PAST_PURCHASES:
      return {
        ...state,
        pastPurchases: action.payload,
      };
    case GET_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload,
      };
    case GET_REVIEWER_INVOICES:
      return {
        ...state,
        reviewerInvoices: action.payload,
      };
    case GET_REVIEWER_PAYMENT_DETAILS:
      return {
        ...state,
        reviewerPaymentDetails: action.payload,
      };
    case UPDATE_REVIEWER_PAYMENT_DETAILS:
      return {
        ...state,
        reviewerPaymentDetails: action.payload,
      };
    case APPROVE_REVIEWER_INVOICE:
      // Update the invoice status in the list
      if (state?.reviewerInvoices && state.reviewerInvoices?.results) {
        const updatedResults = state.reviewerInvoices.results?.map((invoice) =>
          invoice.id === action.payload.id
            ? { ...invoice, status: action.payload.status, approved_at: action.payload.approved_at }
            : invoice
        );
        return {
          ...state,
          reviewerInvoices: {
            ...state.reviewerInvoices,
            results: updatedResults,
            pending_count: state.reviewerInvoices.pending_count - 1,
          },
        };
      }
      return state;
    case REJECT_REVIEWER_INVOICE:
      // Update the invoice status in the list
      if (state?.reviewerInvoices && state?.reviewerInvoices?.results) {
        const updatedResults = state?.reviewerInvoices?.results?.map((invoice) =>
          invoice?.id === action?.payload?.id ? action?.payload : invoice
        );
        return {
          ...state,
          reviewerInvoices: {
            ...state?.reviewerInvoices,
            results: updatedResults,
            pending_count: state?.reviewerInvoices?.pending_count - 1,
          },
        };
      }
      return state;
    case GET_REVIEWER_INVOICE_PDF:
      return {
        ...state,
        reviewerInvoicePdf: action.payload,
      };
    default:
      return state;
  }
}
